/* eslint-disable i18next/no-literal-string -- css not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

export const progress = defineSlotRecipe({
  slots: ['root', 'track', 'range', 'label', 'valueText'],
  className: 'chakra-progress',
  variants: {
    variant: {
      outline: {
        track: {
          shadow: 'inset',
          bgColor: 'bg.muted',
        },
        range: {
          bgColor: 'colorPalette.solid',
        },
      },
      subtle: {
        track: {
          bgColor: 'bg.muted',
        },
        range: {
          bgColor: 'colorPalette.solid',
        },
      },
      stepped: {
        track: {
          borderLeftRadius: 'lg',
          borderRightRadius: 'lg',
        },
      },
    },

    shape: {
      square: {},
      rounded: {
        track: {
          borderRadius: 'l1',
        },
      },
      full: {
        track: {
          borderRadius: 'full',
        },
      },
    },
  },

  defaultVariants: {
    variant: 'subtle',
    shape: 'full',
  },
});
